export class Common {

  constructor() {

  }

  init_header_nav() {
    // ヘッダーメニュー　大トグルボタンの設定
    const nav_toggle = document.getElementsByClassName('site-HeaderNav_Drawer_Toggle');
    const nav_menu = document.getElementsByClassName('site-HeaderNav_Menu');
    const header = document.getElementsByClassName('site-Header');
    const container = document.getElementsByClassName('wp_nav_menu-container');

    nav_toggle[0].addEventListener('click', function () {
      nav_toggle[0].classList.toggle('open');
      nav_menu[0].classList.toggle('open');
      container[0].classList.toggle('open');

      if (header[0].classList.contains('open') === true) {
        header[0].classList.add('closing');

        setTimeout(function () {
          header[0].classList.remove('closing');
        }, 400);

        header[0].classList.remove('open');
      } else {
        header[0].classList.add('open');
        header[0].classList.remove('closing');
      }
    });
  }

  set_smooth_scroll() {
    // aタグ要素の参照を取得
    const links = document.querySelectorAll('a[href^="#"]');

    // 各aタグにクリックイベントを設定
    for (let i = 0; i < links.length; i++) {
      links[i].addEventListener('click', (e) => {
        // デフォルトのイベントをキャンセル
        e.preventDefault();

        const target = document.getElementById(links[i].hash.slice(1));

        // 画面上部から要素までの距離
        const rectTop = target.getBoundingClientRect().top;
        // 現在のスクロール距離
        const offsetTop = window.pageYOffset;
        // スクロール位置に持たせるバッファ
        const buffer = window.innerWidth <= 900 ? 220 : 100;
        // 対象までのスクロール量を算出
        const top = rectTop + offsetTop - buffer;

        window.scroll({
          top: top,
          behavior: 'smooth'
        });
      });
    }
  }
}






